package br.com.texeratx.boardgametimeapp.ui.screens.players.detail

import br.com.texeratx.boardgametimeapp.domain.usecases.player.DeletePlayerUseCase
import br.com.texeratx.boardgametimeapp.domain.usecases.player.GetPlayerDetailsUseCase
import cafe.adriel.voyager.core.model.ScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.launch

class PlayerDetailViewModel(
    private val getPlayerDetail: GetPlayerDetailsUseCase,
    private val deletePlayerUseCase: DeletePlayerUseCase,
) : ScreenModel {


    val player = MutableStateFlow<PlayerDetailUIModel?>(null)
    val isLoading = MutableStateFlow(false)
    val error = MutableStateFlow<String?>(null)
    val uiMessage = MutableStateFlow<String?>(null)
    val isDeleting = MutableStateFlow(false)

    fun loadPlayer(playerId: Long) {
        screenModelScope.launch {
            isLoading.value = true
            error.value = null

            getPlayerDetail(playerId)
                .onSuccess { player.value = it }
                .onFailure { error.value = it.message }

            isLoading.value = false
        }
    }

    fun deletePlayer(
        playerId: Long,
        onSuccess: () -> Unit
    ) {
        screenModelScope.launch {
            isDeleting.value = true

            deletePlayerUseCase(playerId)
                .onSuccess {
                    onSuccess()
                }
                .onFailure {
                    uiMessage.value = it.message ?: "NÃ£o foi possÃ­vel deletar o jogador."
                }

            isDeleting.value = false
        }
    }
}
